import { Component, Inject, OnDestroy } from '@angular/core';
import { UntypedFormArray, UntypedFormBuilder, UntypedFormControl, UntypedFormGroup } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TicketFilter } from '@shared/models/help-ticket.model';
import { DaysOpenOption, ICatalog, PlainOption } from '@shared/models/icommons.model';
import { SharedService } from '@shared/services/shared.service';
import { TicketServiceService } from '@shared/services/ticket-service.service';
import moment from 'moment';
import { SelectItem } from 'primeng/api';
import { take } from 'rxjs/operators';

/**
 * @deprecated There is no reference of this component in the codebase.
 */
@Component({
  selector: 'miq-ticket-filter',
  templateUrl: './ticket-filter.component.html',
  styleUrls: ['./ticket-filter.component.scss'],
  standalone: false,
})
export class TicketFilterComponent implements OnDestroy {
  filterForm: UntypedFormGroup;
  statusOptions: ICatalog[] = [];

  daysOpenOptions: DaysOpenOption[] = [
    {
      value: 'shared.lessThanSixDays',
      key: {
        gte: moment().subtract(6, 'd').format('YYYY-MM-DD'),
      },
    },
    {
      value: 'shared.lessThanThirtyDays',
      key: {
        gte: moment().subtract(30, 'd').format('YYYY-MM-DD'),
      },
    },
    {
      value: 'shared.greaterThanThirtyDays',
      key: {
        lte: moment().subtract(30, 'd').format('YYYY-MM-DD'),
      },
    },
    {
      value: 'shared.greaterThanSixtyDays',
      key: {
        lte: moment().subtract(60, 'd').format('YYYY-MM-DD'),
      },
    },
  ];

  attachmentOptions: any[] = [
    { key: true, value: 'shared.yes' },
    { key: false, value: 'shared.no' },
  ];

  createdByUsers: PlainOption[] = [];
  assignToUsers: PlainOption[] = [];
  createdBySelectItems: SelectItem[] = [];
  assignToSelectItems: SelectItem[] = [];
  sortEvent: { sortBy: any; sortOrder: any };
  selectedFilters: TicketFilter;
  statusIdsSelected: any = {};

  constructor(
    public dialogRef: MatDialogRef<TicketFilterComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private fb: UntypedFormBuilder,
    private sharedService: SharedService,
    private ticketService: TicketServiceService
  ) {
    this.selectedFilters = data.selectedFilters;
    this.selectedFilters.statusId.forEach(id => (this.statusIdsSelected[id] = true));
    this.createdByUsers = data.createdByUsers;
    this.assignToUsers = data.assignedToUsers;
    this.createdBySelectItems = this.createdByUsers.map(
      user => ({ label: user.value, value: user.key }) as any as SelectItem
    );
    this.assignToSelectItems = this.assignToUsers.map(
      user => ({ label: user.value, value: user.key }) as any as SelectItem
    );
    const selectedDate = this.selectedFilters && this.selectedFilters.date ? this.selectedFilters.date : {};
    this.filterForm = this.fb.group({
      statusId: this.fb.array(this.selectedFilters.statusId || []),
      date: selectedDate || {},
      hasAttachments: this.selectedFilters.hasAttachments,
      createdBy: [this.selectedFilters.createdBy],
      assignedTo: [this.selectedFilters.assignedTo],
    });
    this.sharedService
      .getServiceTicketStatuses()
      .pipe(take(1))
      .subscribe(result => (this.statusOptions = result));
  }

  close() {
    this.dialogRef.close();
  }

  reset() {
    this.statusIdsSelected = {};
    this.filterForm = this.fb.group({
      statusId: this.fb.array(this.data.defaultFilters.statusId || []),
      date: this.data.defaultFilters.date,
      hasAttachments: this.data.defaultFilters.hasAttachments,
      createdBy: [this.data.defaultFilters.createdBy],
      assignedTo: [this.data.defaultFilters.assignedTo],
    });
    this.data.defaultFilters.statusId.forEach(id => (this.statusIdsSelected[id] = true));
  }

  onStatusChange(event) {
    const statusId = this.filterForm.get('statusId') as UntypedFormArray;
    if (event.checked) {
      this.statusIdsSelected[event.source.value] = true;
      // tslint:disable-next-line:radix
      return statusId.push(new UntypedFormControl(parseInt(event.source.value)));
    }
    this.statusIdsSelected[event.source.value] = false;
    const i = statusId.controls.findIndex(x => x.value === event.source.value);
    return statusId.removeAt(i);
  }

  apply(formValue) {
    this.dialogRef.close(formValue);
  }

  ngOnDestroy() {
    /** label translation purpose added */
    this.ticketService.setServiceTicketsFilters(this.filterForm.value);
  }
}
